import type { LucideIcon } from 'lucide-react';
import type { ComponentPropsWithRef, JSX } from 'react';

export type IconProps = Omit<ComponentPropsWithRef<'svg'>, 'fill'> & {
  readonly 'data-slot'?: string;
  readonly filled?: boolean;
  readonly size?: number | string;
};
export type IconComponentProps = IconProps & {
  readonly glyph: LucideIcon;
  readonly fillable?: boolean;
};

export function Icon({
  glyph: Glyph,
  filled = false,
  fillable = true,
  size = 16,
  strokeWidth = 1.5,
  'aria-hidden': ariaHidden,
  ...props
}: IconComponentProps): JSX.Element {
  const decorative = ariaHidden ?? !(props['aria-label'] || props['aria-labelledby']);
  const hasFill = filled && fillable;
  return (
    <Glyph
      {...props}
      size={size}
      strokeWidth={strokeWidth}
      fill={hasFill ? 'currentColor' : 'none'}
      aria-hidden={decorative}
      role={props.role ?? (decorative ? undefined : 'img')}
      focusable={props.focusable ?? false}
      data-filled={hasFill}
      data-slot={props['data-slot'] ?? 'icon'}
    />
  );
}
